<template>
  <section class="hero is-info">
    <div class="hero-body">
      <div class="container">
        <h1 class="title">
          {{title}}
        </h1>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'banner',
  props: ['title'],
};
</script>

<style lang="scss" scoped>
.hero {
  background: url('../assets/banner.jpg') no-repeat;
  background-size: cover;
  margin-bottom: 2em;
}
</style>
